module.exports = __webpack_public_path__ + "static/img/BO.6b039cbd.svg";